import { observable } from "mobx";

import Node from "../model/account/Node";

export interface CurrentOwner extends Node {
  [key: string]: any;
}

class Context {
  @observable
  public owner: CurrentOwner;

  public get currentOwner(): CurrentOwner {
    return this.owner;
  }

  public setCurrentOwner(value: CurrentOwner) {
    this.owner = value;
  }
}

const context = new Context();

export default context;
